import { Component, inject } from '@angular/core';

import { ActivateAccountComponent } from '../activate-account.component';

@Component({
  selector: 'app-activate-account-form-state',
  templateUrl: './activate-account-form-state.component.html',
  styleUrls: ['./activate-account-form-state.component.scss'],
  standalone: false,
})
export class ActivateAccountFormStateComponent {
  public readonly activateAccount = inject(ActivateAccountComponent);
}
